import type { Environment } from "@sg-protect/runtime-config";
import { createLocalStorageLaunchDarklyClient } from "@squide/firefly";
import type { LDContext } from "launchdarkly-js-client-sdk";
import { initialize as initializeLaunchDarkly } from "launchdarkly-js-client-sdk";
import { DefaultTestFeatureFlags } from "./featureFlagKeys.ts";

const MswFeatureFlagsLocalStorageKey = "msw-feature-flags";

export function createFeatureFlagClient(env: Environment, clientId: string, ldContext: LDContext) {
    if (env === "msw") {
        return createLocalStorageLaunchDarklyClient(DefaultTestFeatureFlags, {
            localStorageKey: MswFeatureFlagsLocalStorageKey
        });
    } else {
        return initializeLaunchDarkly(clientId, ldContext, {
            // It's important to use the stream mode to receive feature flags
            // updates in real time.
            streaming: true
        });
    }
}
